import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import { AppMedia, AppLink } from '.';
import State from '../store/store'

interface SectionHeroProductOwner {
    __component?: string;
    data?: any;
}

export const SectionHeroProductOwner: FunctionalComponent<SectionHeroProductOwner> = ({ data }) => {

    const { Title, Subtitle, Media } = data;
    const RegisterWarrantyCTA = get(State, 'website.RegisterWarrantyCTA') || 'Register Warranty'

    return (
        <section class="uk-light">
            <div class="uk-container uk-container-large">
                <div class="uk-child-width-1-1 uk-child-width-1-2@s uk-grid-collapse uk-grid-match" uk-grid>
                    <div class="uk-height-min-medium uk-height-min-50@s">
                        <div class="uk-position-relative uk-background-primary-diag uk-flex uk-flex-column">
                            <div class="uk-padding-large uk-flex-1 uk-flex uk-flex-middle">
                                <div>
                                    <div class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</div>
                                    <h1 class="uk-heading-xlarge uk-margin-remove-top uk-margin-medium-bottom">{Title}</h1>
                                    <div class="uk-margin-top uk-flex@m">
                                        <AppLink className="uk-button uk-button-default" data={{ URL: '/warranty-registration', Label: RegisterWarrantyCTA }} ></AppLink>
                                        <div class="uk-margin-medium-left uk-margin-top"></div>
                                        <AppLink data={{ URL: '/contact', Label: 'Contact Spares' }} className="uk-button uk-button-text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-height-min-medium uk-muted-striped uk-visible@s">
                        <AppMedia media={Media} eager size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 45vw" />
                    </div>
                </div>
            </div>
        </section>
    )
};